import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class HolidaysMasterService {
  constructor(private http: HttpClient, private httpService: HttpService) {

  }
  getHolidaysList() {
      var request = {
          URL: "holidays/getHolidays/",
      }
      return this.httpService.get(request);
   }


  getWeeklyOffList() {
      var request = {
          URL: "weeklyOff/getweeklyOff/",
      }
      return this.httpService.get(request);
  }

  updateWeeklyOff(updatedWeeklyOff) {
      var request = {
          URL: "weeklyOff/edit/",
          DATA: updatedWeeklyOff
      }
      return this.httpService.post(request);
  }


  updateHoliday(updatedHoliday) {
      var request = {
          URL: "holidays/edit/",
          DATA: updatedHoliday
      }
      return this.httpService.post(request);
  }

  addHoliday(newHoliday) {
      var request = {
          URL: "Holidays/add/",
          DATA: newHoliday
      }
      return this.httpService.post(request);
  }

  getHolidayById(holidayId: string) {
      var request = {
          URL: "holidays/getHolidayById/" + holidayId
      }
      return this.httpService.get(request);
  }

  deleteHoliday(holidayId) {
      var request = {
          URL: 'holidays/delete/' + holidayId,
      }
      return this.httpService.get(request);
  }

  addSaturdayHoliday(newHoliday) {
      var request = {
          URL: "Holidays/addSaturdays/",
          DATA: newHoliday
      }
      return this.httpService.post(request);
  }

}